export default "__VITE_ASSET__BhZnCv6w__"